import { render, staticRenderFns } from "./SalesByClassMarket.vue?vue&type=template&id=6825e7ea&"
import script from "./SalesByClassMarket.vue?vue&type=script&lang=js&"
export * from "./SalesByClassMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports